// extracted by mini-css-extract-plugin
module.exports = {"dialog":"LinkUsersToStudyModal_dialog__2CPRd","headerIcon":"LinkUsersToStudyModal_headerIcon__27VPB"};